import { useContext, useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import PersonnelIdentityContext from "src/contexts/data/PersonnelIdentityContext";
import { createPersonnelSubMenu } from "src/routing/navigation";

const PersonnelSubMenu: React.FC = () => {
    const { data: personnelIdentity } = useContext(PersonnelIdentityContext);

    const subMenu = useMemo(() => {
        if (!personnelIdentity) {
            return null;
        }

        return createPersonnelSubMenu(personnelIdentity);
    }, [personnelIdentity]);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default PersonnelSubMenu;
